import React, { FC } from 'react';

interface ShareAlertProps {
  alertText: string;
}

const ShareAlert: FC<ShareAlertProps> = ({ alertText }) => {
  return (
    <div className="share-alert">
      <span>{alertText}</span>
    </div>
  );
};

export default ShareAlert;
